/**
 * 部门管理 web api
 * @author Risin.Xu
 * @create 2021-01-18 14:48:49
 */
import request from "@/utils/request";
import service from "@/utils/service"


/**
 * 方案状态
 */
export function deptTypeList() {
  return [
    {id: 1, label: "部门"},
    {id: 2, label: "公司"}
  ]
}

/**
 * 部门职能类型
 */
export function dutyTypeList() {
  return [
    {id: 2, label: "总部职能部门"},
    {id: 3, label: "子公司"},
    {id: 4, label: "子公司职能部门"}
  ]
}


/**
 * 查询部门管理列表
 */
export function listTree(param) {
  return request({
    url: service.tcode + "/base/deptdoc/listTree",
    method: "post",
    data: param
  });
}

/**
 * 查询部门列表
 */
export function list(param) {
  return request({
    url: service.tcode + "/base/deptdoc/list",
    method: "post",
    data: param
  })
}

/**
 * 启用
 */
export function unseal(pk) {
  return request({
    url: service.tcode + "/base/deptdoc/unseal/" + pk,
    method: "get"
  });
}

/**
 * 封存
 */
export function seal(pk) {
  return request({
    url: service.tcode + "/base/deptdoc/seal/" + pk,
    method: "get"
  });
}

/**
 * 根据PK查询一个部门管理
 */
export function get(pk) {
  return request({
    url: service.tcode + "/base/deptdoc/get/" + pk,
    method: "get"
  });
}

/**
 * 保存部门管理数据
 */
export function save(data) {
  return request({
    url: service.tcode + "/base/deptdoc/save",
    method: "post",
    data: data
  });
}


/**
 * 根据PK查询一个门店管理
 * @param pks 主键数组
 */
/*export function deleteBatch(pks) {
  return request({
    url: service.tcode +  "/base/deptdoc/deleteBatch",
    method: "post",
    data: pks
  })
}*/

/**
 * 根据PK删除 部门管理
 * @param pk 主键
 */
/*export function delData(pk) {
  return request({
    url: service.tcode +  "/base/deptdoc/delete/" + pk,
    method: "get"
  })
}*/








// WEBPACK FOOTER //
// ./src/api/base/deptdoc.js